import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Briefcase, FileText, CheckSquare, User, Star, LayoutDashboard, Users, Megaphone, Store } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export const BottomNav = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  let items;
  if (user?.role === "employer") {
    items = [
      { key: "overview", label: t("employer.tabs.overview"), icon: LayoutDashboard, path: "/employer" },
      { key: "ejobs", label: t("employer.tabs.jobs"), icon: Briefcase, path: "/employer/jobs" },
      { key: "eapps", label: t("employer.tabs.applications"), icon: CheckSquare, path: "/employer/applications" },
      { key: "eplans", label: t("employer.tabs.plans"), icon: Star, path: "/employer/plans" },
    ];
  } else if (user?.role === "admin" || user?.role === "subadmin") {
    items = [
      { key: "aover", label: t("admin.tabs.overview"), icon: LayoutDashboard, path: "/admin" },
      { key: "ausers", label: t("admin.tabs.users"), icon: Users, path: "/admin/users" },
      { key: "ajobs", label: t("admin.tabs.jobs"), icon: Briefcase, path: "/admin/jobs" },
      { key: "aads", label: t("admin.tabs.ads"), icon: Megaphone, path: "/admin/ads" },
    ];
  } else {
    items = [
      { key: "jobs", label: t("nav.jobs"), icon: Briefcase, path: "/jobs", public: true },
      { key: "request", label: t("nav.myRequest"), icon: FileText, path: "/candidate/request" },
      { key: "apps", label: t("nav.applications"), icon: CheckSquare, path: "/candidate/applications" },
      { key: "profile", label: t("nav.profile"), icon: User, path: user ? "/candidate/profile" : "/login", public: true },
    ];
  }

  const go = (item) => {
    if (!item.public && !user) return navigate("/login");
    navigate(item.path);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone-border h-16 flex items-center justify-around px-2 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]"
    >
      {items.map((item) => {
        const Icon = item.icon;
        const active = isActive(item.path);
        return (
          <button
            key={item.key}
            data-testid={`bottomnav-${item.key}`}
            onClick={() => go(item)}
            className={`flex flex-col items-center gap-0.5 px-2 py-1 transition-colors ${active ? "text-brand" : "text-stone-muted"}`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
